export default __webpack_public_path__ + "static/media/localtext.879693fb.csv";